//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LeonPopup',
  data () {
    return {
      message: '',
      time: 3000,
      isShow: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonPopup/src/main.vue